export const getUserAgent = () => {
    const nav = navigator;
    if (nav.userAgentData) {
        const { brands, mobile, platform } = nav.userAgentData;
        const brandString = brands.map((b) => `${b.brand}/${b.version}`).join(', ');
        return `${brandString} (${platform}${mobile ? '; Mobile' : ''})`;
    }
    return navigator.userAgent;
};
